/* eslint-disable-next-line  no-unused-vars */
import React, { createElement } from 'react';
import { ListItemIcon, MenuItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Clear, FormatShapes, Timeline } from '@mui/icons-material';
import actionEnums from '../helper/actionEnums';

export default function MeasureMenu({ setAction }) {
    function distanceMeasure() {
        setAction(actionEnums.measurePolyline);
    }

    function areaMeasure() {
        setAction(actionEnums.measurePolygon);
    }

    function clearMeasure() {
        setAction(actionEnums.clearMeasure);
    }

    return (
        <>
            <MenuItem className="action-menu-item" onClick={distanceMeasure}>
                <ListItemIcon>
                    <Timeline fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit">{actionEnums.measurePolyline.label}</Typography>
            </MenuItem>
            <MenuItem className="action-menu-item" onClick={areaMeasure}>
                <ListItemIcon>
                    <FormatShapes fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit">{actionEnums.measurePolygon.label}</Typography>
            </MenuItem>
            <MenuItem className="action-menu-item" onClick={clearMeasure}>
                <ListItemIcon>
                    <Clear fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit" noWrap>
                    Clear Measurement
                </Typography>
            </MenuItem>
        </>
    );
}
